var data = {
  en: {
    translation: {
      signables: {
        actions: {
          create_signature: 'Create Signature',
          sign_and_accept: 'Sign and Accept'
        },
        headings: {
          setup_signature: 'Set Up Your Signature',
          finalize_document: 'Final E-Signature Consent'
        },
        labels: {
          click_to_add_signature: 'Click to add your signature',
          initials: 'Initials',
          your_full_name: 'Your full name'
        },
        messages: {
          create_your_signature: 'Please enter your full name and initials below. By typing ' + 'your name and initials and clicking “Create Signature”, you agree ' + 'that you are creating your electronic signature and your electronic initials.',
          affirmative_consent: 'This is a legally binding document. By clicking “Sign and Accept”, ' + 'you agree that you have the authority to enter into the ' + 'agreement and are creating your electronic signature and signing the document ' + 'just as if you had used a pen to ink sign the document.'
        }
      }
    }
  },
  es: {
    translation: {
      signables: {
        actions: {
          create_signature: 'Establecer firma',
          sign_and_accept: 'Firmar y Aceptar'
        },
        headings: {
          setup_signature: 'Establecer su firma',
          finalize_document: 'Finalizar el consentimiento de firma electrónica'
        },
        labels: {
          click_to_add_signature: 'Haga clic para añadir su firma',
          initials: 'Iniciales',
          your_full_name: 'Su nombre completo'
        },
        messages: {
          create_your_signature: 'En la parte inferior, por favor ingrese su nombre completo e iniciales. ' + 'Al escribir su nombre e iniciales y hacer clic en "Crear firma", usted acepta ' + 'que está creando su firma e iniciales electrónicas.',
          affirmative_consent: 'Este es un documento legalmente vinculante. Al hacer clic en "Firmar y Aceptar", ' + 'usted acepta que tiene la autoridad para celebrar el acuerdo y está creando su ' + 'firma electrónica y firmando el documento como si hubiera usado un bolígrafo para ' + 'firmar el documento con tinta.'
        }
      }
    }
  }
};
export default data;